export const PHONE_INPUT_MAX_DIGITS = 10;
export const US_PHONE_LENGTH = 10;
export const IL_PHONE_LENGTH = 9;
export const US_COUNTRY_CODE = '1';
export const IL_COUNTRY_CODE = '972';

/**
 * Convert a stored 10-digit national phone number to E.164.
 *
 * The app stores phone numbers as 10 raw digits (MedicareCoverageStep strips
 * non-digits and clamps to 10), but hello-server's phone/OTP endpoints expect
 * E.164. Mirrors the mobile app's helper: no libphonenumber.
 *
 * The app is US-only for patients, but ACCESS testers are in Israel, so a
 * number entered with a leading 0 (the Israeli trunk prefix, e.g. 0521234567)
 * is treated as an Israeli mobile instead of a US one. A real US number can
 * never start with 0 (NANP area codes disallow it), so this is unambiguous
 * and safe to leave on in every environment.
 *
 * Returns null (rather than guessing) for anything that isn't exactly 10
 * digits — including an 11-digit value that already carries a country code,
 * which is rejected rather than silently normalized.
 */
export const toE164 = (raw: string): string | null => {
  const digits = raw.replace(/\D/g, '');
  if (digits.length !== PHONE_INPUT_MAX_DIGITS) return null;
  if (digits.startsWith('0')) return `+${IL_COUNTRY_CODE}${digits.slice(1)}`;
  return `+${US_COUNTRY_CODE}${digits}`;
};
